import AuthContext from "context/AuthContext";
import { useContext } from "react";
import TableAssetWaste from "./waste/TableAssetWaste";
import TableAssetBridge from "./bridge/TableAssetBridge";

const TableAssetContainerManager = (props) => {
    const { panel } = useContext(AuthContext);

    switch (panel.panel_type) {
        case 'b':
            return <TableAssetBridge {...props} />;
        default:
            return <TableAssetWaste {...props} />;
    };
};
export default TableAssetContainerManager;